// extracted by mini-css-extract-plugin
module.exports = {"sectionCourseList":"ItemMultiple_sectionCourseList_kwbvz","sectionIntro":"ItemMultiple_sectionIntro_22qY9","sessionFixed":"ItemMultiple_sessionFixed_1qw4S"};